<div class="loads" [style.height]="height" [style.width]="width"></div>
